import blogPost from '../post-card/post-card.vue';
export default {
    name:'Blog',
    data () {
        return {
        };
    },
    computed:{
        posts: function (){
            return this.$store.state.blogPosts;
        }
    },
    props:[
        'post'
    ],
    components: {
        blogPost
    },
    methods:{
    },
    mounted:function (){
        // show toolbar
        document.getElementById('navBar').style.marginTop = '0px';
    }
};


// WEBPACK FOOTER //
// ./src/components/blog/blog.js